module.exports = __webpack_public_path__ + "static/img/102751.4067285b.png";